import { useAppConfig } from './useAppConfig'
import type { MarketHours } from '../contexts/AppConfigContext'

export const useMarketHours = (): MarketHours => useAppConfig().marketHours
